import React, {useMemo} from 'react';

import MegaMenuImageBlock from './MegeMenuImageBlock';

const MegeMenuImageSection = function ({
  active,
  defaultImages,
  sections,
}) {
  const activeItems = useMemo(function () {
    if (!active) {
      return defaultImages?.images || sections?.[0]?.imagesBlock?.images || []
    }

    return sections[active]?.imagesBlock?.images || sections[active]?.subtree?.['0']?.imagesBlock?.images || []
  }, [active, defaultImages, sections]);

  return (
    <div className="megamenu__second-level-image-block">
      {activeItems?.map((item, index) => (
        <MegaMenuImageBlock {...item} key={item.url + index} />
      ))}
    </div>
  )
}

export default MegeMenuImageSection
